export const COLORS_PLAYGROUND_CARDS = [
  { color1: 'rgba(1, 253, 236, 1)', color2: 'rgba(27, 33, 41, 1)' },
  { color1: 'rgba(159, 62, 254, 1)', color2: 'rgba(0, 12, 39, 1)' },
  { color1: 'rgba(230, 44, 136, 1)', color2: 'rgba(27, 33, 41, 1)' },
  { color1: 'rgba(253, 179, 1, 1)', color2: 'rgba(27, 33, 41, 1)' },
  { color1: 'rgba(59, 62, 240, 1)', color2: 'rgba(27, 33, 41, 1)' },
  { color1: 'rgba(230, 69, 38, 1)', color2: 'rgba(27, 33, 41, 1)' },
];
